export const TENANT_ICON_WIDTH_CLASS = "w-[30px]";
export const TENANT_ICON_HEIGHT_CLASS = "h-[30px]";
